import { get } from '@helpcenter/ajax';
import { Observable } from 'rxjs/Observable';
import { trackError } from '@atlassian/help-center-common-util/analytics';
import { contextPath } from '@atlassian/help-center-common-util/history';

export interface OrganisationsResponse {
    organisations: OrganisationResponse[];
}

export interface OrganisationResponse {
    id: number;
    name: string;
    domain?: string;
}

export const fetchOrganisations = (
    projectId: string,
    reporter: string,
    context: string = contextPath
): Observable<OrganisationResponse[]> => {
    const uri = `${context}/rest/servicedesk/1/customer/organisations/project/${projectId}/member/account/${reporter}`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (
        get(uri)
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            .map(({ response }) => response)
            .catch((e) => {
                trackError('organisation.fetch.failed', {}, e);
                // Rethrow error
                return Observable.throw(e);
            })
    );
};
